// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"13685":"f77da14f2d52b87feec5","34841":"dca9644681373e0e66f7","35624":"09a027b5b13e5a6f5afd","44139":"1f10d6095dcca8e844e5","60745":"31cbb64a9d66d3058e3a","60868":"070b5eac87a3082b695b","68775":"4241fa362725d483058f"}[chunkId] + ".min.js";
};